export default __webpack_public_path__ + "static/media/olivex.8be563b1.svg";